import { StudentService } from 'src/app/core/services/student.service';
import { Student } from 'src/app/core/models/student';
import { EnrollmentService } from 'src/app/core/services/enrollment.service';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { Course } from '../../core/models/course';
import { Enrollment } from 'src/app/core/models/enrollment';
import { DatePipe, formatDate } from '@angular/common';
import KeenSlider, { KeenSliderInstance } from "keen-slider"
import {ElementRef, ViewChild } from "@angular/core";

@Component({
  selector: 'app-student-cources',
  templateUrl: './student-cources.component.html',
  styleUrls: [
    '../../../../node_modules/keen-slider/keen-slider.min.css',
    './student-cources.component.scss']
})
export class StudentCourcesComponent extends BaseComponent implements OnInit {

  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>
  currentSlide: number = 1
  dotHelper: Array<Number> = []
  slider: KeenSliderInstance = null





  userFullName: string;
  studentId: number;

  tokenValid: boolean;

  enrollmentCourses: Enrollment[];
  isTeacher: string;
  enrolledCourses: Course[];

  p: number = 1;
  watchDate: Date;
  today: Date;

  userId: number;
  academyToken: string;
  student = {} as Student

  userName: string;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private enrollmentService: EnrollmentService,
    public datepipe: DatePipe,
    private studentService: StudentService
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');

    this.userName = localStorage.getItem('userName');

    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    var user =  localStorage.getItem('userId');  
    this.userId = Number(user);

    this.academyToken = localStorage.getItem('academyToken'); 

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.enrollmentService.getByStudentId(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.enrollmentCourses = data.result.returnData;
        this.enrolledCourses = this.enrollmentCourses.map(item => item.courses);
        // console.log(this.enrolledCourses)
        // console.log(this.enrollmentCourses)
      }
    )

    this.studentService.get(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.student = data.result.returnData;
      }
    )
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel
        },
      })
      this.dotHelper = [
        ...Array(this.slider.track.details.slides.length).keys(),
      ]
    })
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy()
  }

  viewStudProfile(id) {
    this.router.navigate(['/student-profile/edit', this.studentId])
  }

  viewStudCourses(id) {
    this.router.navigate(['/student-courses/edit', this.studentId]);
  }

  viewStudSettings(id) {
    this.router.navigate(['/student-settings/edit', this.studentId]);
  }

  viewWishlist(id) {
    this.router.navigate(['/wishlist/edit', this.studentId]);
  }

  viewCourseDetails(id) {
    this.router.navigate(['/course-details/edit', id]);
  }

  watchCourse(id, startDate){
    debugger
    // window.open('https://academy-lms.learnyhome.com/index.php?r=adm/homepage/login&plugin=FormaAuth&from_academy=1&login_userid='+ this.userId +'&token='+ this.academyToken + '&course_external_id=' + id, "_blank");
    this.today = new Date();
    this.watchDate = new Date(startDate);
    // console.log(this.today)
    // console.log(this.watchDate)
    // this.watchDate = this.datepipe.transform(startData); 
    // debugger
    if (this.watchDate > this.today) {
      this.alertService.success(this.translate.instant('NotStarted'))
      // window.open('https://academy-lms.learnyhome.com/index.php?r=adm/homepage/login&plugin=FormaAuth&from_academy=1&login_userid='+ this.userId +'&token='+ this.academyToken + '&course_external_id=' + id, "_blank");
      // console.log ('')
    }
    else if (this.watchDate < this.today || this.today === this.watchDate) {
      window.open('https://academy-lms.learnyhome.com/index.php?r=adm/homepage/login&plugin=FormaAuth&from_academy=1&login_userid='+ this.userName +'&token='+ this.academyToken + '&course_external_id=' + id, "_blank");
      // console.log ('تم إرسال الرابط')
    }
  
  }


}
